import _styled from "styled-components";
var _excluded = ["selectedItems", "isOpen", "getComboboxProps", "getInputProps", "removeSelectedItem", "getInputProps", "getSelectedItemProps", "itemToString", "openMenu"],
    _excluded2 = ["style", "css", "onChange"],
    _excluded3 = ["style", "css"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState } from 'react';
import { defaultLabelGetter } from '../helpers';
import { ControlLabel, SearchInput, Token } from '../layout';

var MultiAutocompleteTokenControl = function MultiAutocompleteTokenControl(_ref) {
  var selectedItems = _ref.selectedItems,
      isOpen = _ref.isOpen,
      getComboboxProps = _ref.getComboboxProps,
      getInputProps = _ref.getInputProps,
      removeSelectedItem = _ref.removeSelectedItem,
      getInputPropsProp = _ref.getInputProps,
      getSelectedItemProps = _ref.getSelectedItemProps,
      _ref$itemToString = _ref.itemToString,
      itemToString = _ref$itemToString === void 0 ? function (item) {
    return defaultLabelGetter(item);
  } : _ref$itemToString,
      openMenu = _ref.openMenu,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState({
    width: '0ch'
  }),
      _useState2 = _slicedToArray(_useState, 2),
      inputStyle = _useState2[0],
      setInputStyle = _useState2[1];

  var hasSelectedItems = selectedItems !== null && selectedItems !== void 0 && selectedItems.length ? selectedItems.length > 0 : false;

  var resizeInput = function resizeInput(value) {
    setInputStyle({
      width: "".concat(value.length, "ch")
    });
  };

  var _ref2 = (getInputProps === null || getInputProps === void 0 ? void 0 : getInputProps({
    readOnly: !isOpen,
    onKeyDown: function onKeyDown(e) {
      if (e.target.value.length) {
        // there is text in the input, don't delete an item
        return;
      }

      if (e.key === 'Backspace' && selectedItems !== null && selectedItems !== void 0 && selectedItems.length) {
        removeSelectedItem(selectedItems[(selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.length) - 1]);
      }
    }
  })) || {
    style: undefined
  },
      _ignoredStyle = _ref2.style,
      _ignoredInputCss = _ref2.css,
      inputOnChange = _ref2.onChange,
      inputProps = _objectWithoutProperties(_ref2, _excluded2);

  var handleInputOnChange = function handleInputOnChange(e) {
    resizeInput(e.target.value);
    inputOnChange === null || inputOnChange === void 0 ? void 0 : inputOnChange(e);
  };

  return /*#__PURE__*/React.createElement(ControlLabel, _extends({
    isOpen: isOpen,
    onClick: openMenu
  }, props), /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: [{
      display: 'flex',
      overflowY: 'auto',
      flexWrap: 'wrap',
      flex: 1,
      height: '100%'
    }]
  }, selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.map(function (selectedItem, index) {
    var _getSelectedItemProps = getSelectedItemProps({
      selectedItem: selectedItem,
      index: index
    }),
        tokenStyle = _getSelectedItemProps.style,
        _ignored = _getSelectedItemProps.css,
        selectedItemProps = _objectWithoutProperties(_getSelectedItemProps, _excluded3);

    return /*#__PURE__*/React.createElement(Token, _extends({
      key: "selected-item-".concat(index),
      style: tokenStyle,
      onClickX: function onClickX() {
        return removeSelectedItem(selectedItem);
      }
    }, selectedItemProps, {
      content: itemToString === null || itemToString === void 0 ? void 0 : itemToString(selectedItem)
    }));
  }), /*#__PURE__*/React.createElement(SearchInput, _extends({
    style: inputStyle,
    getComboboxProps: getComboboxProps
  }, inputProps, {
    onChange: handleInputOnChange,
    showIcon: false,
    isOpen: isOpen // undefined will use default, don't show placeholder if we have tokens
    ,
    placeholder: hasSelectedItems ? '' : undefined
  }))));
};

MultiAutocompleteTokenControl.displayName = 'MultiAutocompleteTokenControl';
MultiAutocompleteTokenControl.propTypes = {};
export default MultiAutocompleteTokenControl;

var _StyledDiv = _styled("div").withConfig({
  displayName: "MultiAutocompleteTokenControl___StyledDiv",
  componentId: "sc-1qdwx7z-0"
})(["", ""], function (p) {
  return p.$_css;
});
//# sourceMappingURL=MultiAutocompleteTokenControl.js.map